export default __webpack_public_path__ + "static/our-storybg-950954a250eafbc96ca0401c55c2979d.png";